<template>
  <div :style="cssVars">
    <Stepper :current-step="currentStep" :is-valid="isValid" @changeStep="changeStep" />
    <div class="hwh-calculator__step-wrap">
      <Step1 v-if="currentStep === 1" ref="step1" />
      <Step2 v-if="currentStep === 2" ref="step2" />
      <Step3 v-if="currentStep === 3" ref="step3" />
      <div v-if="showLegal" class="hwh-calculator__legal-close" @click.prevent="showLegal = false"></div>
      <div v-if="showLegal" class="hwh-calculator__legal">
        <div v-if="showFullDisclaimer">
          <p>Based on the comparison of a 50-gallon Rheem Hybrid Electric model to a standard electric water heater of like
            capacity with minimum efficiency; Payback based on average retail cost difference less available incentives and
            annual operating cost savings.</p>

          <p>RHEEM provides this Calculator as a convenience to help customers in analyzing potential cost savings when
            purchasing water heating products. THE CALCULATOR IS ONLY INTENDED FOR USE IN THE UNITED STATES and assumes a
            365-day operation period by the user. The estimates provided by the Calculator are provided to help you
            determine whether you desire to further investigate combined water heating solutions with RHEEM. THE CALCULATOR
            ONLY PROVIDES ESTIMATES. SUCH ESTIMATES ARE NOT A GUARANTEE OF SAVINGS. A NUMBER OF OTHER FACTORS MAY AFFECT
            YOUR ACTUAL SAVINGS, AND YOUR ACTUAL SAVINGS MAY DIFFER. Please carefully read all of the terms of this
            Disclaimer. By viewing and utilizing this Cost Savings Tool, you acknowledge that you have read, agreed to, and
            understand this Disclaimer.</p>

          <p>RHEEM PROVIDES THE CALCULATOR “AS IS” AND WITH ALL FAULTS, AND HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS,
            EITHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING BUT NOT LIMITED TO ANY IMPLIED WARRANTIES OR CONDITIONS OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET ENJOYMENT, OR NON-INFRINGEMENT.</p>

          <p>IN NO EVENT SHALL RHEEM BE LIABLE FOR ANY DAMAGES, INCLUDING CONSEQUENTIAL, INCIDENTAL, DIRECT, INDIRECT,
            SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES ARISING OUT OF OR IN ANY WAY RELATED TO THE USE OF OR INABILITY TO USE
            THE CALCULATOR, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF RHEEM HAS
            BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THIS EXCLUSION OF DAMAGES SHALL BE EFFECTIVE EVEN IF ANY REMEDY
            FAILS ITS ESSENTIAL PURPOSE.</p>

          <p>The Calculator is provided to you at no charge. Rheem has included in this Disclaimer terms that disclaim all
            warranties and liability for the Calculator. To the full extent allowed by law, BY USING THIS CALCULATOR, YOU
            HEREBY RELEASE RHEEM FROM ANY AND ALL LIABILITY ARISING FROM OR RELATED TO THE CALCULATOR OR ITS USE.</p>

          <p>All title and copyrights in and to the Calculator are owned by Rheem Manufacturing Company. All trademarks are
            the property of Rheem Manufacturing Company or its respective owners.</p>

          <p>The laws of the State of Georgia, USA will apply to this Disclaimer.</p>

          <p>If you have any questions or you desire to contact RHEEM for any reason, please write: RHEEM Manufacturing
            Company; 1100 Abernathy Rd., Suite 1400; Atlanta, GA 30342.</p>
        </div>
        <div v-else>
          <p>Rheem provides this Calculator as a convenience to help customers in analyzing potential cost savings when purchasing water heating products.
            The Calculator only provides estimates. Such estimates are not a guarantee of savings. A number of other factors may affect your actual savings and your actual savings may differ.
            Calculations are based on the comparison of a 50-gallon Rheem Hybrid Electric model to a standard electric water heater of like capacity with minimum efficiency.
            Calculator is only intended for use in the United States and assumes a 365-day operation period by the user.</p>
        </div>
      </div>
    </div>

    <div class="hwh-calculator__btn-navigation">
      <div class="hwh-calculator__btn-navigation-back">
        <a href="#" v-if="currentStep > 1" @click.prevent="changeStep(currentStep - 1, true)"
          class="hwh-calculator__btn hwh-calculator__btn--navigation" style="margin-right: 7px;"><svg
            xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
              d="M5.49043 7.78208L9.74043 3.53208C10.0342 3.23833 10.5092 3.23833 10.7998 3.53208L11.5061 4.23833C11.7998 4.53208 11.7998 5.00708 11.5061 5.29771L8.49668 8.31333L11.5092 11.3258C11.8029 11.6196 11.8029 12.0946 11.5092 12.3852L10.8029 13.0946C10.5092 13.3883 10.0342 13.3883 9.74356 13.0946L5.49356 8.84458C5.19668 8.55083 5.19668 8.07583 5.49043 7.78208Z"
              fill="white" />
          </svg> Back</a>
      </div>
      <div class="hwh-calculator__btn-navigation-next">
        <a href="#" v-if="currentStep < 3" @click.prevent="changeStep(currentStep + 1)"
          :class="{ 'hwh-calculator__btn--disabled': !isValid }" style="margin-left: 7px;"
          class="hwh-calculator__btn hwh-calculator__btn--navigation">Next <svg xmlns="http://www.w3.org/2000/svg"
            width="8" height="11" viewBox="0 0 8 11" fill="none">
            <path
              d="M7.00957 4.78208L2.75957 0.53208C2.46582 0.23833 1.99082 0.23833 1.70019 0.53208L0.993944 1.23833C0.700194 1.53208 0.700194 2.00708 0.993944 2.29771L4.00332 5.31333L0.990819 8.32583C0.697069 8.61958 0.697069 9.09458 0.990819 9.3852L1.69707 10.0946C1.99082 10.3883 2.46582 10.3883 2.75644 10.0946L7.00644 5.84458C7.30332 5.55083 7.30332 5.07583 7.00957 4.78208Z"
              fill="white" />
          </svg></a>
        <a href="#" v-if="currentStep === 3" @click.prevent="reset"
          class="hwh-calculator__btn hwh-calculator__btn--navigation" style="margin-left: 7px;">Start over</a>
      </div>
      <div class="hwh-calculator__btn-navigation-option">
        <a href="#" v-if="currentStep === 3" @click.prevent="print"
          class="hwh-calculator__btn hwh-calculator__btn--navigation hwh-calculator__btn--print">Print</a>
        <a href="#" v-if="showSkipBtn" @click.prevent="changeStep(currentStep + 1, true)"
          class="hwh-calculator__btn hwh-calculator__btn--navigation hwh-calculator__btn--print">Skip</a>
      </div>
    </div>
    <div class="hwh-calculator__copy-block" v-if="currentStep > 0">
      <a href="https://www.rheem.com/kwikcomfort-residential/" target="_blank" v-if="showKwikComfort">
        <img :src="`${imgDir}/kwikcomfort2-btn.png`" alt="">
      </a>
      <div class="hwh-calculator__legal-link-block">
        <a href="#" @click.prevent="showLegal = true" class="hwh-calculator__legal-link">Legal Disclaimer</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Stepper from '@/components/Stepper.vue';
import Step1 from '@/components/steps/Step1.vue';
import Step2 from '@/components/steps/Step2.vue';
import Step3 from '@/components/steps/Step3.vue';
import config from '@/config';

export default {
  components: {
    Stepper,
    Step1,
    Step2,
    Step3,
  },
  name: 'Calculator',
  props: {},
  data() {
    return {
      currentStep: 1,
      showLegal: false,
      mainColor: config.MAIN_COLOR,
      roiBackgroundImage: config.ROI_BACKGROUND_IMAGE,
      showKwikComfort: config.SHOW_KWIKCOMFORT_BLOCK,
      showFullDisclaimer: config.FULL_LEGAL_DISCLAIMER,
    };
  },
  methods: {
    ...mapActions(['setIncentiveList', 'setValidZedCode', 'setAvgEnergyRate', 'setAvgEnergyRate']),
    changeStep(step, force = false) {
      if (this.isValid || force) {
        if (this.rebatePrograms.length === 0 && step === 2) {
          this.currentStep = (step + (this.currentStep < step ? 1 : -1));
        } else {
          this.currentStep = step;
        }
      }
      if (this.currentStep === 1 && !this.validZipCode) {
        this.$refs.step1.$refs.zipCode.focus();
      } else if (this.currentStep === 1 && !this.validAvgEnergyRate) {
        this.$refs.step1.$refs.avgEnergyRate.focus();
      }
    },
    reset() {
      this.currentStep = 1;
      this.setIncentiveList([]);
      this.setValidZedCode(null);
      this.setAvgEnergyRate(null);
    },
    print() {
      window.print();
    },
  },
  computed: {
    ...mapState(['validHybridPrice', 'validHybridInstallationPrice', 'validAvgEnergyRate', 'validZipCode', 'isLoading', 'rebatePrograms', 'imgDir']),
    ...mapGetters(['totalRebateValue']),
    isValid() {
      if (this.isLoading) {
        return false;
      }
      if (this.currentStep === 1) {
        return !!this.validHybridPrice && !!this.validHybridInstallationPrice && !!this.validAvgEnergyRate && !!this.validZipCode;
      }
      if (this.currentStep === 2) {
        return !!this.validHybridPrice && !!this.validAvgEnergyRate && !!this.validZipCode && !!this.totalRebateValue;
      }
      return true;
    },
    showSkipBtn() {
      return this.currentStep === 2 && !this.totalRebateValue;
    },
    cssVars() {
      return {
        '--main-color': this.mainColor,
        '--roi-background-image': `url(${this.imgDir}/${this.roiBackgroundImage})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  -webkit-print-color-adjust: exact;
}

@mixin scrollbar($width: 2px) {
  &::-webkit-scrollbar-button {
    background-image: none;
    background-repeat: no-repeat;
    width: $width;
    height: 0;

  }

  &::-webkit-scrollbar-track {
    background-color: #FEFEFE;
    @media print {
      & {
        background-color: #FEFEFE!important;
      }
    }

  }

  &::-webkit-scrollbar-thumb {
    -webkit-border-radius: 0;
    border-radius: 0;
    background-color: #DDD;
    @media print {
      & {
        background-color: #DDD!important;
      }
    }
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #DDD;
  }

  &::-webkit-resizer {
    background-image: none;
    background-repeat: no-repeat;
    width: $width;
    height: 0
  }

  &::-webkit-scrollbar {
    width: $width;
    height: $width;
  }
}

$mainColor: var(--main-color);
$roiImageUrl: var(--roi-background-image);

body {
  margin: 0;
  position: relative;
  padding: 0;
}

::v-deep .hwh-calculator {
  &-header {
    img {
      width: 100%;
    }
  }

  &-stepper {
    background-color: $mainColor;
    color: #FFF;
    @media print {
      & {
        background-color: $mainColor!important;
        color: #FFF!important;
      }
    }

    &__inner {
      position: relative;
      max-width: 612px;
      padding: 15px 15px 10px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }

    &__item {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      text-transform: uppercase;
      z-index: 10;
      cursor: pointer;
      position: relative;
      padding-bottom: 10px;
      transition: font-weight 0.35s;

      @media print {
        & {
          color: #fff!important;
        }
      }

      &:after {
        display: block;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: -1px;
        height: 4px;
        border: 1px solid #FFF;
        transition: background 0.35s;
      }

      &--active {
        font-weight: 700;

        &:after {
          background: #FFF;

          @media print {
            & {
              background: #FFF!important;
            }
          }
        }
      }

      &--disabled {
        cursor: default;
      }
    }
  }

  &__block {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    min-height: 310px;
  }

  &__sub {
    color: #656565;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    line-height: 2.5;
    border-bottom: 1px solid #000;

    @media print {
      & {
        color: #656565!important;
      }
    }
  }

  &__comment {
    text-align: center;
    line-height: 1.5;
    border-top: 1px solid #000;
    padding: 10px;
  }

  &__zip-block {
    text-align: center;
    color: #656565;
    border-bottom: 1px solid #000;
    padding: 6px;
  }

  &__zip-block-inner {
    display: inline-block;
    position: relative;
  }

  &__zip-block-error {
    position: absolute;
    left: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    white-space: nowrap;
    color: $mainColor;
  }

  &__spinner {
    position: relative;
    top: 2px;
    display: inline-block;
    margin-right: 5px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: conic-gradient(#0000 10%, $mainColor);
    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 0);
    animation: spinner-zp9dbg 1s infinite linear;
  }

  @keyframes spinner-zp9dbg {
    to {
      transform: rotate(1turn);
    }
  }

  &__text {
    margin-bottom: 25px;
    min-height: 40px;
    padding: 0 20px;
  }

  &__title {
    display: block;
    font-size: 26px;
    margin: 16px 0 20px 0;
  }

  &__input {
    width: 120px;
    border: 1px solid #656565;
    padding: 3px 5px;
    font-size: 18px;
    color: #656565;
    font-weight: 400;
    border-radius: 0;
    margin: 0;
    text-transform: uppercase;
    border-radius: 4px;

    &:focus {
      outline: none;
      box-shadow: 0 0 5px 0 rgba(#154b7b, 0.3);
    }
  }

  &__input-block {
    font-weight: 700;
    font-size: 18px;
  }

  &__hint {
    font-size: 10px;
    margin-top: 5px;

    &--mb20 {
      margin-bottom: 20px;
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;

    &--350 {
      height: 350px;
    }

    &--356 {
      height: 356px;
    }
  }

  &__col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    height: 100%;

    &--center {
      text-align: center;
    }

    &--border {
      border-right: 1px solid #000;
      ;
    }

    &--bar {}
  }

  &__col-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  &__btn {
    background-color: $mainColor;
    color: #FFF;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 500;
    padding: 0px 20px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;

    @media print {
      & {
        background-color: $mainColor!important;
        color: #FFF!important;
      }
    }

    &--print {
      margin-right: 8px;
    }

    &--disabled {
      opacity: 0.5;
    }

    &:hover {
      color: #FFF;
      text-decoration: none;
    }
  }

  &__btn-block {
    padding-top: 10px;
  }

  &__copy-block {
    padding-top: 20px;
    text-align: center;
  }

  &__total-block {
    text-align: center;
    color: #656565;
    border-top: 1px solid #000;
    padding: 6px;
  }

  &__legal-link-block {
    padding-top: 10px;
  }

  &__legal-link {
    color: $mainColor;

    @media print {
      & {
        color: $mainColor!important;
      }
    }

    &:hover,
    &:focus {
      color: $mainColor;
    }
  }

  &__step-wrap {
    position: relative;
  }

  &__legal {
    position: absolute;
    top: calc(100% + 60px);
    left: 0px;
    right: 0px;
    overflow-y: auto;
    background: #FFF;
    padding: 25px 40px;
    border: 1px solid #000;
    z-index: 11;
    max-height: 250px;
    @include scrollbar(4px);

    @media print {
      & {
        max-height: unset;
        overflow-y: unset;
        background: #FFF!important;
      }
    }
  }

  &__legal-close {
    cursor: pointer;
    right: 10px;
    top: calc(100% + 70px);
    position: absolute;
    width: 32px;
    height: 32px;
    background-image: url(../assets/img/ico-close.svg);
    z-index: 12;
    @media print {
      & {
        background-image: url(../assets/img/ico-close.svg)!important;
      }
    }
  }

  &__result {
    height: calc(100% - 24px);
    padding: 5px 30px;
    position: relative;

    &-block {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #6f7271;
      max-width: 200px;
      position: relative;
      line-height: 1;

      &:last-child {
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
      }

      &-label {
        font-size: 12px;
        color: #6f7271;
        margin: 5px 0;
        padding: 0;
        height: auto;
        font-weight: 400;
        @media print {
          & {
            color: #6f7271!important;
          }
        }
      }

      &-value {
        color: #adc587;
        font-size: 36px;
        font-weight: bold;
        line-height: 1;

        span {
          font-size: 24px;
          @media print {
            & {
              color: #adc587!important;
            }
          }
        }
        @media print {
          & {
            color: #adc587!important;
          }
        }
      }

      &-hint {
        position: absolute;
        right: 0;
        background-color: #bebebe;
        color: #FFF;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        font-size: 10px;
        font-weight: 700;
        border-radius: 50%;
        cursor: pointer;

        @media print {
          & {
            background-color: #bebebe!important;
            color: #FFF!important;
          }
        }

        &:hover {
          .hwh-calculator__result-block-popup {
            visibility: visible;
            opacity: 1;
          }
        }
      }

      &-popup {
        position: absolute;
        right: 16px;
        top: -16px;
        z-index: 2;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.35s;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        white-space: nowrap;
        align-items: center;
        font-size: 14px;
        font-weight: 300;
        padding: 26px 8px;
        border-radius: 16px;

        img {
          max-width: initial;
        }

        .symbol {
          font-size: 48px;
          font-weight: 100;
          padding: 0 5px 3px;

          &--sm {
            font-size: 24px;
          }

          &--sep {}
        }
      }
    }

    &--bg {
      background-image: $roiImageUrl;
      background-repeat: no-repeat;
      background-position: bottom right 30px;
      padding-top: 40px;

      @media print {
        & {
          background-image: $roiImageUrl!important;
          background-repeat: no-repeat!important;
          background-position: bottom right 30px!important;
        }
      }

      @media (max-width: 420px) {
        & {
          background-position: bottom right 20px;
          @media print {
            & {
              background-position: bottom right 20px!important;
            }
          }
        }
      }
    }
  }

  &__header {
    text-align: center;
    background: #efefef;
    color: #656565;
    font-size: 12px;
    font-weight: bold;
    line-height: 2;
    box-shadow: 0 3px 3px 0 rgb(0 0 0 / 35%);
    @media print {
      & {
        background: #efefef!important;
        color: #656565!important;
      }
    }
    @media (max-width: 420px) {
      & {
        font-size: 11px;
      }
    }
  }

  &__slider {
    margin: 6px;

    .swiper-wrapper {
      max-height: 350px;
    }
  }

  &__slide {
    width: 370px;
    overflow: hidden;
    height: auto;

    &-inner {
      display: block;
      padding: 10px 10px 0 40px;
      border: 1px solid #DDD;
      height: 338px;
      overflow-y: auto;
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      @include scrollbar;
    }

    &-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
    }

    &-disabled {
      font-size: 12px;
      margin-left: -8px;
      color: $mainColor;
      margin-bottom: 10px;
      @media print {
        & {
          color: $mainColor!important;
        }
      }
    }

    &-price {
      font-size: 16px;
      font-weight: 400;
    }

    &-link {
      font-size: 12px;
      color: $mainColor;
      font-weight: 600;

      @media print {
        & {
          color: $mainColor!important;
        }
      }
    }

    &-text {
      font-size: 12px;

      ul {
        padding-left: 12px;
        list-style: initial;
        margin-top: 5px;
      }

      li {
        margin-bottom: 3px;
        word-wrap: break-word;
      }
    }

    &-checkbox {
      position: absolute;
      left: 10px;
      margin: 0;
      float: none;

      &[disabled] {
        display: none;
      }
    }
  }

  &__bar {
    position: absolute;
    bottom: 0;
    width: 40%;
    transition: height 0.35s;
    height: 0;

    &-label {
      position: absolute;
      top: -60px;
      font-size: 12px;
      text-align: center;
      left: 0;
      right: 0;
    }

    &-value {
      font-size: 18px;
      font-weight: 600;
    }

    &--electric {
      background-color: #bebebe;
      left: 5%;

      @media print {
        & {
          background-color: #bebebe!important;
        }
      }

      .hwh-calculator__bar-value {
        color: #bebebe;

        @media print {
          & {
            color: #bebebe!important;
          }
        }
      }
    }

    &--hybrid {
      background-color: #adc687;
      right: 5%;

      @media print {
        & {
          background-color: #adc687!important;
        }
      }

      .hwh-calculator__bar-value {
        color: #adc687;

        @media print {
          & {
            color: #adc687!important;
          }
        }
      }
    }
  }

  &__btn-navigation {
    border: 1px;
    display: flex;
    margin-top: 16px;

    &-back {
      order: 1;
    }

    &-next {
      order: 3;
      display: flex;
      justify-content: flex-end;
      order: 3;
    }

    &-option {
      order: 2;
      margin-left: auto;
      padding-right: 10px;
    }

    @media (max-width: 767px) {
      flex-wrap: wrap;

      .btn-wrapper {
        margin: 16px 0 0 0;
        width: 100%;
      }

      &-back {
        width: 50%;
      }

      &-next {
        width: 50%;
        order: 2;
              }

      &-option {
        width: 100%;
        order: 3;
        padding: 10px 0px;
      }

    }
  }
}

/* @media mobile device */
@media (max-width: 767px) {

  ::v-deep .hwh-calculator {
    &__legal {
      top: calc(100% + 130px);
    }

    &__legal-close {
      top: calc(100% + 140px);
    }

    &__btn--navigation {
      margin-bottom: 0 !important;
      width: 100% !important;
    }

    // Step 1
    &__cost-rate-wrapper-mob {
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      height: auto;
      border: 1px solid black;
      border-radius: 0px 0px 8px 8px;

      >div:nth-child(-n+2) {
        padding: 14px 10px;
        min-height: unset;
      }
    }

    &__cost--border {
      border-bottom: 1px solid black;
      border-right: none;
    }

    &__hint {
      font-size: 12px;
      margin-top: 10px;
    }

    &__title {
      margin: 0 0 10px 0 !important;
    }

    &__block {
      border: none;
    }

    &__sub {
      border: 1px solid #000;
    }

    &__zip-block {
      border: none;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
      height: 60px;
    }

    &__zip-block-error {
      font-size: 14px;
      white-space: nowrap;
      color: $mainColor;
      position: relative;
      left: unset;
      top: unset;
      transform: unset;
    }

    // Step 3

    &__step-3 {
      >div:nth-child(-n+2) {
        border: 0 solid black;
        border-width: 0 1px;
      }

      .hwh-calculator__col--border {
        border: unset;
      }
    }

    &__comment {
      border: 1px solid black;
      border-radius: 0px 0px 8px 8px;
    }

    &__chart-wrap-mob {
      display: flex;
      flex-direction: column;
    }

    &__btn {
      display: flex;
      width: 152px;
      padding: 8px 24px 8px 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;

    }

  }
}

@media(max-width: 991px) {

  ::v-deep .hwh-calculator {
    &__slide {
      width: 310px;
    }

    &__title {
      font-size: 20px;
      margin: 16px 0 10px 0;
      padding: 0 20px;
    }

    &__input {
      width: 80px;
    }

    &__text {
      padding: 0 6px;
    }

    &__row--356 {
      height: auto;
    }

    &__step-3 {
      .hwh-calculator__row {
        flex-direction: column;
      }
    }

    &__col--bar {
      flex: 0 0 100%;
      max-width: 100%;
    }

    &__comment {
      line-height: 1.6;
      padding: 5px 10px;
    }

    &__result-block {
      padding-left: 20px;
    }

    &__result-block-hint {
      right: auto;
      left: 0;
    }

    &__result-block-popup {
      width: calc(100vw - 64px);
      right: auto;
      flex-wrap: wrap;
      justify-content: center;

      img {
        width: 100%;
      }

      .symbol {
        &--sep {
          flex: 0 0 100%;
          max-width: 100%;
          margin: 10px;
        }
      }
    }

    &__btn {
      margin: 0 0 10px;
      padding: 0px;
      height: 44px;
    }
  }
}
</style>
